import { Component, inject } from '@angular/core';
import { BaseWidgetComponent } from '../../../../../home/home-widgets/widgets/base-widget.component';
import { FilterService } from '../../../../../_shared/services/filter.service';
import { KpiWidgetComponent } from '../../../../../_shared/components/kpi-widget/kpi-widget.component';
import { SummaryRequest } from '../../../../../_shared/models';
import { AssetOverviewService } from '../../../services/asset-overview.service';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-operational-assets',
  standalone: true,
  imports: [KpiWidgetComponent],
  templateUrl: './operational-assets.component.html',
  styleUrl: './operational-assets.component.scss'
})
export class OperationalAssetsComponent extends BaseWidgetComponent {
  hasError: boolean = false;
  errorMessage: string = '';

  private assetOverviewService = inject(AssetOverviewService);
  private errorHandlerService = inject(ErrorHandlerService);
  private readonly transloco: TranslocoService = inject(TranslocoService);

  constructor() {
    const filterService: FilterService = inject(FilterService);
    super(filterService);

    this.title = this.transloco.translate('assetOverview.widgets.operationalAssets');
    this.isLoading = true;
    this.value = 0;
    this.percentageDifference = 0;
  }

  protected override async onFilterChangeAsync(): Promise<void> {
    this.hasError = false;
    this.isLoading = true;
    this.errorMessage = '';

    try {
      const request: SummaryRequest = {
        accountIds: this.widgetFilter.accountIds,
        timeFrom: this.widgetFilter.startDate!,
        timeTo: this.widgetFilter.endDate!,
        previousTimeFrom: this.widgetFilter.previousCycleStartDate!,
        previousTimeTo: this.widgetFilter.previousCycleEndDate!
      };

      this.cancelSubject.next();
      const response = await this.assetOverviewService.getOperationalAssets(request, this.cancelSubject);
      this.value = response?.data?.totalValue ?? 0;
      this.percentageDifference = response?.data?.percentageChange ?? 0;

      this.isLoading = false;
    } catch (error) {
      this.errorHandlerService.handleError(error, {
        callback: (message) => {
          this.errorMessage = message;
          this.hasError = true;
          this.isLoading = false;
        }
      });
    }
  }

  public override formatValue(value: number): string {
    return `${value.toLocaleString()}`;
  }
}